import { Check, Loader } from 'lucide-react'
import Icon from '@/shared/v2/shared/components/Icon'

export type StepStatus = 'done' | 'active' | 'pending'

const StepIcon = ({ status }: { status: StepStatus }) => {
    if (status === 'done') return <Icon icon={Check} className="text-textPositive" />
    if (status === 'active') return <Icon icon={Loader} className="animate-spin" />
    return <div className="w-4 h-4 rounded-full border border-borderPrimary" />
}

export default StepIcon
